import { Divider, Table } from 'semantic-ui-react';
import styled from 'styled-components';

export const IndividualPhaseWrapper = styled.div`
 .disabled {
   opacity: 0.9 !important;
 }
 .phase-counter {
   margin-top: 37px;
   font-size: 16px !important;
 }
 input {
  width: 300px !important;
 }
`
export const StyledDivider = styled(Divider)`
background: ${props => props.theme.firstColor} !important;
margin-top: 1em !important;
margin-bottom: 0.5em;
`
export const HeaderColumnTitle = styled(Table.HeaderCell)`
background: white !important;
color: ${props => props.theme.firstColor} !important;
text-align: center !important;
border: 1px solid !important;
`